export default "__VITE_ASSET__DPlzZNGD__"